export const useStatamicNavTree = () => {
    const statamic = useStatamic()

    const getNavTree = (data) => statamic(`/navs/${data.handle}/tree`)

    return {
        getNavTree,
    }
}
